<style lang="scss">
.calculation-row {
  margin: 2rem;
  border: 2px solid color(primary);
  background-color: color(primary);
  color: white;

  h1 {
    padding: 1rem;
    text-align: center;
    font-family: 'Roboto', sans-serif;
  }
}
</style>

<template>
  <v-row
    class="calculation-row"
  >
    <v-col
      :size="12"
    >
      <v-row>
        <v-col
          :size="12"
        >
          <h1>Milk Prices</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          :size="4"
          class="col--no-padding"
        >
          <calculation
            :inputs="calculations.swp_gouda.inputs"
            :result="calculations.swp_gouda.result"
          />
        </v-col>
        <v-col
          :size="4"
          class="col--no-padding"
        >
          <calculation
            :inputs="calculations.wmp.inputs"
            :result="calculations.wmp.result"
          />
        </v-col>
        <v-col
          :size="4"
          class="col--no-padding"
        >
          <calculation
            :inputs="calculations.smp_butter.inputs"
            :result="calculations.smp_butter.result"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Calculation from '@/views/Home/Valorization/Calculations/Calculation';

export default {
  name: 'CalculationRow',
  components: {
    Calculation,
  },
  props: {
    calculations: {
      type: Object,
      required: true,
    },
  },
};
</script>
